<template>
  <div>
    <el-form ref="ktcxForm" label-width="120px" :hide-required-asterisk="false">
      <div class="card">
        <el-row>
          <el-col :span="24" class="label">
            {{ cancelApplyForm.courseName }}
          </el-col>
        </el-row>
        <div class="card_content">
          <div>
            <span>课题编号:</span>
            <span>{{ cancelApplyForm.courseId }}</span>
          </div>
          <div>
            <span>课题负责人:</span>
            <span>{{ cancelApplyForm.courseLeaderName }}</span>
          </div>
          <div>
            <span>课题主要成员:</span>
            <span>{{ cancelApplyForm.memberName }}</span>
          </div>
          <el-row>
            <el-col :span="12">
              <div>
                <span style="margin-right: 30px">立项时间:</span>
                <span>{{ cancelApplyForm.itemTime }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <span style="margin-right: 30px">
                <span class="red_star">*</span>
                原结项时间:
              </span>
              <span
                ><el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="cancelApplyForm.knotItemTime"
                  :clearable="false"
                />
              </span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> 检查内容说明 </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" key="9">
            <div class="result_content">
              <div style="padding: 0 15px 15px 15px">
                <div style="color: #000; font-weight: 700">
                  <span class="red_star">*</span>
                  一、课题基本情况：
                </div>
                <div id="wangEditor"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card">
        <el-row>
          <el-col :span="24" key="9">
            <div class="result_content">
              <div style="padding: 0 15px 15px 15px">
                <div style="color: #000; font-weight: 700">
                  <span class="red_star">*</span>
                  二、撤销原因：
                </div>
                <div id="wangEditor2"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import { formatMomentDate, sizeFormat, checkVal } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  getCancelApply,
  saveCancelApply,
  delCancelApply,
} from "@/api/course.js";
import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      height: 500,
      rules: [],
      cancelApplyForm: [
        {
          courseId: "",
          cancelId: null,
          knotItemTime: null,
          courseSituation: "",
          cancelReason: "",
          status: "",
          step: "",
          courseLeaderName: "",
          memberName: "",
          itemTime: "",
          courseName: "",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    this.editor = editor;
    this.editor2 = editor2;
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },

    getData() {
      getCancelApply({ courseId: this.mxParams.courseId }).then((res) => {
        if (res.code == 0) {
          this.cancelApplyForm = res.data;
          if (this.cancelApplyForm.knotItemTime) {
            this.cancelApplyForm.knotItemTime = moment(
              this.cancelApplyForm.knotItemTime
            );
          }
          this.editor.txt.html(this.cancelApplyForm.courseSituation);
          this.editor2.txt.html(this.cancelApplyForm.cancelReason);
        }
      });
    },
    saveForm() {
      this.cancelApplyForm.courseSituation = this.editor.txt.html();
      this.cancelApplyForm.cancelReason = this.editor2.txt.html();
      if (!this.cancelApplyForm.knotItemTime) {
        this.$message.error("请输入原结项时间");
        return;
      }
      if (!this.cancelApplyForm.courseSituation) {
        this.$message.error("一、课题基本情况");
        return;
      }
      if (!this.cancelApplyForm.cancelReason) {
        this.$message.error("二、撤销原因");
        return;
      }
      if (this.cancelApplyForm.knotItemTime) {
        this.cancelApplyForm.knotItemTime = formatMomentDate(
          new Date(this.cancelApplyForm.knotItemTime)
        );
      }
      saveCancelApply(this.cancelApplyForm).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("getParentForm");
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    delApply() {
      delCancelApply({ cancelId: this.cancelApplyForm.cancelId }).then(
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$emit("getParentForm");
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
.red_star {
  color: #ff0000;
  margin-right: 5px;
}
</style>